import React from 'react';
import {
    Datagrid,
    TextField,
    DateField,
    ChipField,
    ReferenceManyField,
    Pagination,
    useListContext,
} from 'react-admin';

import MoneyField from '../components/MoneyField';

const DatagridWithTotal = props => {
    const { total, loaded } = useListContext();

    return (
        <>
            {loaded && (
                <div
                    style={{
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgba(0, 0, 0, 0.87)',
                    }}
                >
                    Total Charges: {total || 0}
                </div>
            )}
            <Datagrid>
                <TextField source="serial" sortable={false} />
                <TextField source="id" />
                <DateField locales="en-IN" source="createdAt" label="Created" />
                <TextField source="type" />
                <TextField source="year" />
                <TextField source="month" />
                <TextField source="startDate" label="start" />
                <TextField source="endDate" label="end" />
                <MoneyField source="amount" showCurrency />
                <ChipField source="invoiceId" label="Invoice" />
                <TextField source="description" />
            </Datagrid>
            <Pagination />
        </>
    );
};

const Charges = props => (
    <ReferenceManyField
        {...props}
        addLabel={false}
        reference="charges"
        target="storageId"
        perPage={25}
    >
        <DatagridWithTotal />
    </ReferenceManyField>
);

Charges.defaultProps = {
    resource: 'charges',
    location: { search: '' },
};

export default Charges;
